export var ReportCategoryInclude = {
    reports: true,
};
//# sourceMappingURL=ReportCategory.js.map